import React from 'react';
import { Button } from 'antd';
import { ButtonType } from 'antd/es/button/buttonHelpers';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Catcher } from '../';
import { tB } from '../../translate';
import Styles from '../styles/m_itemCardStyles.less';

type ICancelButton = {
    danger?: boolean;
    dataTest?: string;
    icon?: React.ReactNode;
    isDisable?: boolean;
    isHideIcon?: boolean;
    onClick: () => void;
    type?: ButtonType;
};

export const CancelButton: React.FC<ICancelButton> = ({
    danger,
    dataTest,
    icon = <CloseCircleOutlined />,
    isDisable,
    isHideIcon,
    onClick,
    type = 'primary',
}: ICancelButton) => {
    return (
        <Catcher>
            <Button
                className={Styles.mainButton}
                data-test={dataTest}
                disabled={isDisable}
                icon={isHideIcon ? undefined : icon}
                onClick={onClick}
                type={type}
                danger={danger}
            >
                {tB('Cancel')}
            </Button>
        </Catcher>
    );
};
